import React, { useState } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Typography,
  IconButton,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const SidebarAnchors = ({ sections }) => {
  const [openSections, setOpenSections] = useState(() =>
    sections.reduce((acc, section) => {
      if (section.children) acc[section.id] = true;
      return acc;
    }, {})
  );

  const toggleSection = (id) => {
    setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <Box
      sx={{
        maxHeight: '85vh',
        overflowY: 'auto',
        pr: 1,
        scrollbarWidth: 'thin',           // Firefox
        scrollbarColor: 'transparent transparent', // Firefox
        '&::-webkit-scrollbar': {
          width: '6px',                    // Chrome/Safari
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          borderRadius: '3px',
        },
        '&:hover::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        }
      }}
    >
      <Typography
        variant="h6"
        gutterBottom
        sx={(theme) => ({ color: theme.palette.accent.main })}
      >
        Sections
      </Typography>
      <List dense>
        {sections.map(({ id, title, children }) => (
          <Box key={id}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <ListItemButton component="a" href={`#${id}`} sx={{ flexGrow: 1 }}>
                <ListItemText primary={title} />
              </ListItemButton>
              {children && (
                <IconButton size="small" onClick={() => toggleSection(id)}>
                  {openSections[id] ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              )}
            </Box>
            {children && (
              <Collapse in={openSections[id]} timeout="auto" unmountOnExit>
                <List dense sx={{ pl: 3 }}>
                  {children.map((child) => (
                    <ListItemButton
                      key={child.id}
                      component="a"
                      href={`#${child.id}`}
                    >
                      <ListItemText primary={child.title} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            )}
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default SidebarAnchors;
